var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import 'font-awesome/css/font-awesome.min.css';
import { createBrowserHistory } from 'history';
import * as React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
// import 'simple-line-icons/css/simple-line-icons.css';
import './App.css';
import appReduxProps from './AppReduxProps';
import AppRoutes from './config/appRoutes';
import AppLayout from './layouts/appLayout';
import AuthenticationLayout from './layouts/authLayout';
import NotFound from './views/NotFound/NotFound';
import UnauthUser from './views/UnauthUser/UnauthUser';
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.history = createBrowserHistory();
        return _this;
    }
    App.prototype.componentDidMount = function () {
        // TODO
    };
    App.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Switch, null,
                React.createElement(Route, { path: AppRoutes.login.path, component: UnauthUser, key: AppRoutes.login.key, exact: true }),
                React.createElement(Route, { path: AppRoutes.notFound.path, component: NotFound }),
                React.createElement(Route, { path: AppRoutes.notAuth.path, component: AuthenticationLayout }),
                React.createElement(Route, { path: AppRoutes.base.path, component: AppLayout }))));
    };
    return App;
}(React.Component));
export default connect(null, appReduxProps.mapDispatchToProps)(App);



//////////////////
// WEBPACK FOOTER
// ./src/App.tsx
// module id = 201
// module chunks = 0